import React from 'react';

const ContactPersonCard = ({ person }) => {
  return (
    <div className="contact-column">
      <p><strong>Jméno:</strong> {person.name}</p>
      <p><strong>Pozice:</strong> {person.position}</p>
      <p><strong>Telefon:</strong> {person.contact.phone}</p>
      <p><strong>Email:</strong> {person.contact.email}</p>
    </div>
  );
};

export default ContactPersonCard; 